<template>
  <section id="page-foobars-list">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row" v-show="loading">
        <div class="col-sm-12 content fb-bg-light">
          <loading-spinner></loading-spinner>
        </div>
      </div>

      <div class="row" v-show="foobars.length === 0 && !loading">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          {{ $t('message.text.no_foobars') }}
        </div>
      </div>

      <div class="row" v-show="foobars.length > 0" v-for="fb in foobars">
        <clearfix :wide="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div class="foobar-edit-menu" v-show="$store.state.auth.editor">
            <span :title="$t('message.icon.title.news_status_' + fb.status)"
                  v-show="fb.status === 'NEWS' || fb.status === 'AVAILABLE'"
                  @click="updateStatus(fb.id, (fb.status === 'NEWS' ? 'AVAILABLE' : 'NEWS'))">
              <icon name="beer" :class="'is-enabled-' + (fb.status === 'NEWS')"></icon>
            </span>
            <span :title="$t('message.icon.title.hide')" v-show="fb.status === 'NEWS' || fb.status === 'AVAILABLE'"
                  @click="updateStatus(fb.id, 'HIDDEN')">
              <icon name="eye" class="is-enabled-true"></icon>
            </span>
            <span :title="$t('message.icon.title.show')" v-show="fb.status !== 'NEWS' && fb.status !== 'AVAILABLE'"
                  @click="updateStatus(fb.id, 'AVAILABLE')">
              <icon name="eye-slash" class="is-enabled-false"></icon>
            </span>
            <span :title="$t('message.icon.title.edit')"
                  @click="$router.push({ name: 'FoobarEditor', params: { id: fb.id } })">
              <icon name="pencil"></icon>
            </span>
            <span :title="$t('message.icon.title.delete')" v-show="fb.status !== 'DELETED'"
                  @click="updateStatus(fb.id, 'DELETED')">
              <icon name="trash"></icon>
            </span>
          </div>

          <h4>
            <router-link :to="{name: 'Foobar', params: {id: fb.id}}">{{ fb.title }}</router-link>
          </h4>

          <div class="foobar-description" v-html="fb.description"></div>
        </div>
      </div>

      <clearfix :biggest="true"></clearfix>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import miniToastr from 'mini-toastr'
  import LoadingSpinner from '@/components/utils/LoadingSpinner'
  import Clearfix from '@/components/utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        foobars: [],
        loading: true
      }
    },
    components: {
      Clearfix, Icon, LoadingSpinner
    },
    methods: {
      updateStatus(foobarId, status) {
        Vue.axios.put(this.$t(config.urls.foobar_update_status, {foobar_id: foobarId}), {data: status})
          .then(() => {
            this.loadFoobars()
            miniToastr.success(this.$t('message.text.saved'))
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_foobar_failed'))
          })
      },
      loadFoobars() {
        Vue.axios.get(config.urls.foobar)
          .then((response) => {
            this.foobars = response.data
            this.loading = false
          })
      }
    },
    created() {
      this.loadFoobars()
    }
  }
</script>

<style>
  #page-foobars-list {
    background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// FoobarList.vue?5b369ae0